<template>
  <!--startprint-->
  <div class="printMain" style="width: 500px;">
    <div id="printChart">
      <div class="comInfo">
        <div class="date">{{ date }}</div>
        <div class="compName">{{ comInfo.company_name }}</div>
        <div>CIF: {{ comInfo.duty }}</div>
        <div>Dirección: {{ comInfo.address }}</div>
        <div>C.P.: {{ comInfo.code }}</div>
        <div>Telf.: {{ comInfo.tel }}</div>
        <div>Email: {{ comInfo.email }}</div>
      </div>
      <div class="line"></div>
      <div class="table">
        <div class="item">
          <div>Fecha</div>
          <div>Cantidad de pedido</div>
          <div>Importe Total</div>
        </div>
      </div>
      <div class="line"></div>
      <div class="table">
        <div class="item" v-for="(val, key) in orderList" :key="key">
          <div>{{ val.create_time }}</div>
          <div>{{ val.order_id }}</div>
          <div>{{ val.amount }}</div>
        </div>
      </div>
      <div class="line"></div>
      <div class="table">
        <div class="item">
          <div>Total Ventas</div>
          <div>{{ total.total_order }}</div>
          <div>{{ total.total_price }}</div>
        </div>
      </div>
    </div>
  </div>
  <!--endprint-->
</template>

<script>
import print from 'print-js';

import Company from '@/api/base';
import Home from '@/api/home';
export default {
  name: 'printMonthOrder',
  props: {
    date: String,
  },
  data() {
    return {
      comInfo: {},
      orderList: [],
      total: {},
    };
  },
  watch: {
    date(res) {
      if (res != '') {
        this.printContent();
      }
    },
  },
  created() {
    console.log(print);
    Company.compamyInfo().then(res => {
      if (res.data != false) {
        this.comInfo = res.data;
      }
    });
  },
  methods: {
    printContent() {
      var param = this.date.split('-');
      Home.chat({ year: param[0], month: param[1] }).then(res => {
        this.orderList = res.data.list;
        this.total = {
          total_order: res.data.total_order,
          total_price: res.data.total_price,
        };
        this.$nextTick(() => {
          printJS({
            printable: 'printChart',
            targetStyles: ['*'],
            type: 'html',
          });
          this.$emit('printed');
        });
      });
    },
  },
};
</script>

<style lang="less">
.printMain {
  position: fixed;
  top: 100vh;
  font-size: 14px;
  #printChart {
    padding: 0 20px;
    .line {
      width: 100%;
      border-bottom: 1px solid #000000;
      transform: scaleY(0.3);
      margin: 10px 0;
    }
    .table {
      .item {
        display: flex;
        margin-bottom: 5px;
        & > div {
          &:nth-child(1) {
            width: 120px;
          }
          &:nth-child(2) {
            width: 150px;
            text-align: center;
          }
          &:nth-child(3) {
            flex: 1;
            margin-left: 50px;
            text-align: center;
          }
        }
      }
    }
  }
  .comInfo {
    .date {
      text-align: right;
      padding-right: 20px;
      font-size: 12px;
    }
    .compName {
      font-weight: bolder;
    }
    & > div:nth-child(n + 1) {
      margin-bottom: 5px;
    }
  }
}
</style>
